<template>
  <div class="text-gray-600 proDivClass">
    <div class="px-4 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl sm:px-6 md:px-8 lg:px-10 lg:py-10">
      <div class="flex justify-center items-center pt-10">
        <img :src="baseOSSUrl + '/news-1.png'" alt="" class="h-5 w-5">
        <p class="w-40 h-9 text-2xl text-center leading-9 text-lg font-bold tracking-widest">专家资源</p>
        <img :src="baseOSSUrl + '/news-1.png'" alt="" class="h-5 w-5">
      </div>
      <div class="flex flex-wrap w-full flex-col items-center text-center mt-4">
<!--        <p class="lg:w-1/2 w-full leading-relaxed text-gray-400">-->
<!--          Whatever cardigan tote bag tumblr hexagon brooklyn asymmetrical gentrify, subway tile poke farm-to-table.-->
<!--        </p>-->
      </div>


      <div class="grid gap-10 mx-auto sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4  py-10">
        <!--    第一位    -->
        <div>
          <div class="relative proImg overflow-hidden transition duration-300 transform rounded shadow-lg lg:hover:-translate-y-2 hover:shadow-2xl">
            <img class="object-cover proImg" :src="img1" alt="" />
            <div class="absolute inset-0 flex flex-col justify-center px-5 py-4 text-center transition-opacity duration-300 bg-black bg-opacity-75 opacity-0 hover:opacity-100">
              <p class="mb-1 text-lg font-bold text-gray-100">
                {{img1Title}}
              </p>
              <p class="mb-1 text-lg font-bold text-gray-100">
                {{img1EnTitle}}
              </p>
              <p class="mb-4 text-xs text-gray-100"></p>
              <p class="mb-4 text-xs tracking-wide text-gray-400">
                {{img1Address}}
              </p>
            </div>
          </div>
        </div>
        <!-- 第二位 -->
        <div>
          <div class="relative proImg overflow-hidden transition duration-300 transform rounded shadow-lg lg:hover:-translate-y-2 hover:shadow-2xl">
            <img class="object-cover proImg" :src="img2" alt="Person" />
            <div class="absolute inset-0 flex flex-col justify-center px-5 py-4 text-center transition-opacity duration-300 bg-black bg-opacity-75 opacity-0 hover:opacity-100">
              <p class="mb-1 text-lg font-bold text-gray-100">{{img2Title}}</p>
              <p class="mb-1 text-lg font-bold text-gray-100">
                {{img2EnTitle}}
              </p>
              <p class="mb-4 text-xs text-gray-100"></p>
              <p class="mb-4 text-xs tracking-wide text-gray-400">
                {{img2Address}}
              </p>
            </div>
          </div>
        </div>

        <!--  第三位      -->
<!--        <div>-->
<!--          <div class="relative proImg overflow-hidden transition duration-300 transform rounded shadow-lg lg:hover:-translate-y-2 hover:shadow-2xl">-->
<!--            <img class="object-cover proImg" :src="img3" alt="Person" />-->
<!--            <div class="absolute inset-0 flex flex-col justify-center px-5 py-4 text-center transition-opacity duration-300 bg-black bg-opacity-75 opacity-0 hover:opacity-100">-->
<!--              <p class="mb-1 text-lg font-bold text-gray-100">{{img3Title}}</p>-->
<!--              <p class="mb-4 text-xs text-gray-100"></p>-->
<!--              <p class="mb-4 text-xs tracking-wide text-gray-400">-->
<!--                {{img3Address}}-->
<!--              </p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <!--    第四位    -->
        <div>
          <div class="relative proImg overflow-hidden transition duration-300 transform rounded shadow-lg lg:hover:-translate-y-2 hover:shadow-2xl">
            <img class="object-cover proImg" :src="img4" alt="Person" />
            <div class="absolute inset-0 flex flex-col justify-center px-5 py-4 text-center transition-opacity duration-300 bg-black bg-opacity-75 opacity-0 hover:opacity-100">
              <p class="mb-1 text-lg font-bold text-gray-100">{{img4Title}}</p>
              <p class="mb-1 text-lg font-bold text-gray-100">
                {{img4EnTitle}}
              </p>
              <p class="mb-4 text-xs text-gray-100"></p>
              <p class="mb-4 text-xs tracking-wide text-gray-400">
                {{img4Address}}
              </p>
            </div>
          </div>
        </div>
        <!--    第五位    -->
<!--        <div>-->
<!--          <div class="relative proImg overflow-hidden transition duration-300 transform rounded shadow-lg lg:hover:-translate-y-2 hover:shadow-2xl">-->
<!--            <img class="object-cover proImg" :src="img5" alt="Person" />-->
<!--            <div class="absolute inset-0 flex flex-col justify-center px-5 py-4 text-center transition-opacity duration-300 bg-black bg-opacity-75 opacity-0 hover:opacity-100">-->
<!--              <p class="mb-1 text-lg font-bold text-gray-100">{{img5Title}}</p>-->
<!--              <p class="mb-4 text-xs text-gray-100"></p>-->
<!--              <p class="mb-4 text-xs tracking-wide text-gray-400">-->
<!--                {{img5Address}}-->
<!--              </p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <!--   第六位     -->
<!--        <div>-->
<!--          <div class="relative proImg overflow-hidden transition duration-300 transform rounded shadow-lg lg:hover:-translate-y-2 hover:shadow-2xl">-->
<!--            <img class="object-cover proImg" :src="img6" alt="Person" />-->
<!--            <div class="absolute inset-0 flex flex-col justify-center px-5 py-4 text-center transition-opacity duration-300 bg-black bg-opacity-75 opacity-0 hover:opacity-100">-->
<!--              <p class="mb-1 text-lg font-bold text-gray-100">{{img6Title}}</p>-->
<!--              <p class="mb-4 text-xs text-gray-100"></p>-->
<!--              <p class="mb-4 text-xs tracking-wide text-gray-400">-->
<!--                {{img6Address}}-->
<!--              </p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <!--  第七位      -->
<!--        <div>-->
<!--          <div class="relative proImg overflow-hidden transition duration-300 transform rounded shadow-lg lg:hover:-translate-y-2 hover:shadow-2xl">-->
<!--            <img class="object-cover proImg" :src="img7" alt="Person" />-->
<!--            <div class="absolute inset-0 flex flex-col justify-center px-5 py-4 text-center transition-opacity duration-300 bg-black bg-opacity-75 opacity-0 hover:opacity-100">-->
<!--              <p class="mb-1 text-lg font-bold text-gray-100">{{img7Title}}</p>-->
<!--              <p class="mb-4 text-xs text-gray-100"></p>-->
<!--              <p class="mb-4 text-xs tracking-wide text-gray-400">-->
<!--                {{img7Address}}-->
<!--              </p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <!--   第八位     -->
<!--        <div>-->
<!--          <div class="relative proImg overflow-hidden transition duration-300 transform rounded shadow-lg lg:hover:-translate-y-2 hover:shadow-2xl">-->
<!--            <img class="object-cover proImg" :src="img8" alt="Person" />-->
<!--            <div class="absolute inset-0 flex flex-col justify-center px-5 py-4 text-center transition-opacity duration-300 bg-black bg-opacity-75 opacity-0 hover:opacity-100">-->
<!--              <p class="mb-1 text-lg font-bold text-gray-100">{{img8Title}}</p>-->
<!--              <p class="mb-4 text-xs text-gray-100"></p>-->
<!--              <p class="mb-4 text-xs tracking-wide text-gray-400">-->
<!--                {{img8Address}}-->
<!--              </p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <!--   第九位     -->
<!--        <div>-->
<!--          <div class="relative proImg overflow-hidden transition duration-300 transform rounded shadow-lg lg:hover:-translate-y-2 hover:shadow-2xl">-->
<!--            <img class="object-cover proImg" :src="img9" alt="Person" />-->
<!--            <div class="absolute inset-0 flex flex-col justify-center px-5 py-4 text-center transition-opacity duration-300 bg-black bg-opacity-75 opacity-0 hover:opacity-100">-->
<!--              <p class="mb-1 text-lg font-bold text-gray-100">{{img9Title}}</p>-->
<!--              <p class="mb-4 text-xs text-gray-100"></p>-->
<!--              <p class="mb-4 text-xs tracking-wide text-gray-400">-->
<!--                {{img9Address}}-->
<!--              </p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

        <div>
          <div class="relative proImg overflow-hidden transition duration-300 transform rounded shadow-lg lg:hover:-translate-y-2 hover:shadow-2xl">
            <img class="object-cover proImg" :src="img10" alt="Person" />
            <div class="absolute inset-0 flex flex-col justify-center px-5 py-4 text-center transition-opacity duration-300 bg-black bg-opacity-75 opacity-0 hover:opacity-100">
              <p class="mb-1 text-lg font-bold text-gray-100">{{img10Title}}</p>
              <p class="mb-1 text-lg font-bold text-gray-100">
                {{img10EnTitle}}
              </p>
              <p class="mb-4 text-xs text-gray-100"></p>
              <p class="mb-4 text-xs tracking-wide text-gray-400">
                {{img10Address}}
              </p>
            </div>
          </div>
        </div>

        <div>
          <div class="relative proImg overflow-hidden transition duration-300 transform rounded shadow-lg lg:hover:-translate-y-2 hover:shadow-2xl">
            <img class="object-cover proImg" :src="img11" alt="Person" />
            <div class="absolute inset-0 flex flex-col justify-center px-5 py-4 text-center transition-opacity duration-300 bg-black bg-opacity-75 opacity-0 hover:opacity-100">
              <p class="mb-1 text-lg font-bold text-gray-100">{{img11Title}}</p>
              <p class="mb-1 text-lg font-bold text-gray-100">
                {{img11EnTitle}}
              </p>
              <p class="mb-4 text-xs text-gray-100"></p>
              <p class="mb-4 text-xs tracking-wide text-gray-400">
                {{img11Address}}
              </p>
            </div>
          </div>
        </div>

        <div>
          <div class="relative proImg overflow-hidden transition duration-300 transform rounded shadow-lg lg:hover:-translate-y-2 hover:shadow-2xl">
            <img class="object-cover proImg" :src="img12" alt="Person" />
            <div class="absolute inset-0 flex flex-col justify-center px-5 py-4 text-center transition-opacity duration-300 bg-black bg-opacity-75 opacity-0 hover:opacity-100">
              <p class="mb-1 text-lg font-bold text-gray-100">{{img12Title}}</p>
              <p class="mb-1 text-lg font-bold text-gray-100">
                {{img12EnTitle}}
              </p>
              <p class="mb-4 text-xs text-gray-100"></p>
              <p class="mb-4 text-xs tracking-wide text-gray-400">
                {{img12Address}}
              </p>
            </div>
          </div>
        </div>

        <div>
          <div class="relative proImg overflow-hidden transition duration-300 transform rounded shadow-lg lg:hover:-translate-y-2 hover:shadow-2xl">
            <img class="object-cover proImg" :src="img13" alt="Person" />
            <div class="absolute inset-0 flex flex-col justify-center px-5 py-4 text-center transition-opacity duration-300 bg-black bg-opacity-75 opacity-0 hover:opacity-100">
              <p class="mb-1 text-lg font-bold text-gray-100">{{img13Title}}</p>
              <p class="mb-1 text-lg font-bold text-gray-100">
                {{img13EnTitle}}
              </p>
              <p class="mb-4 text-xs text-gray-100"></p>
              <p class="mb-4 text-xs tracking-wide text-gray-400">
                {{img13Address}}
              </p>
            </div>
          </div>
        </div>

        <div>
          <div class="relative proImg overflow-hidden transition duration-300 transform rounded shadow-lg lg:hover:-translate-y-2 hover:shadow-2xl">
            <img class="object-cover proImg" :src="img14" alt="Person" />
            <div class="absolute inset-0 flex flex-col justify-center px-5 py-4 text-center transition-opacity duration-300 bg-black bg-opacity-75 opacity-0 hover:opacity-100">
              <p class="mb-1 text-lg font-bold text-gray-100">{{img14Title}}</p>
              <p class="mb-1 text-lg font-bold text-gray-100">
                {{img14EnTitle}}
              </p>
              <p class="mb-4 text-xs text-gray-100"></p>
              <p class="mb-4 text-xs tracking-wide text-gray-400">
                {{img14Address}}
              </p>
            </div>
          </div>
        </div>



      </div>
    </div>
  </div>
</template>

<script>
import {
baseOSSUrl
} from '@/utils/oss';
export default {
  name: "homeProResource",
  data(){
    return {
      baseOSSUrl,
      img1: baseOSSUrl + '/joseLuisPomar.png',
      img1Title:"何塞·路易斯·波马尔博士",
      img1EnTitle:"Dr. José Luis Pomar",
      img1Address:"巴塞罗那医院心血管外科高级顾问、巴塞罗那大学医学院外科学教授、欧洲心胸外科协会（EACTS）前任主席",

      img2: baseOSSUrl + '/josepMpique.jpg',
      img2Title:"约瑟夫·皮克博士",
      img2EnTitle:"Dr.Josep Maria Piqué",
      img2Address:"安道尔公共卫生局首席执行官、西班牙巴塞罗那医院前任院长",

      // img3: baseOSSUrl + '/josepBrugadaTerradellas.jpg"),
      // img3Title:"Josep Brugada Terradellas 博士",
      // img3Address:"巴塞罗那大学医学系教授、巴塞罗那医院医务主任",

      img4: baseOSSUrl + '/martaSitges.png',
      img4Title:"玛尔塔·锡切斯博士",
      img4EnTitle:"Dr. Marta Sitges",
      img4Address:"巴塞罗那医院诊所心血管研究所主任",

      // img5: baseOSSUrl + '/torstenDoenst.jpg"),
      // img5Title:"Dr. Torsten Doenst （托斯滕·多恩斯特 )",
      // img5Address:"心血管外科专家",

      // img6: baseOSSUrl + '/rainerHambrecht.jpg"),
      // img6Title:"Dr. Rainer Hambrecht (莱纳 ·哈姆布莱希特)",
      // img6Address:"心血管外科专家",

      // img7: baseOSSUrl + '/eikeSebastianDebus.jpg"),
      // img7Title:"Dr. Eike Sebastian Debus(埃克·塞巴斯甜·德布斯 ）",
      // img7Address:"心血管外科专家",

      // img8: baseOSSUrl + '/hs.jpg"),
      // img8Title:"汉斯-海宁·埃科施泰恩",
      // img8Address:"心血管外科专家",

      // img9: baseOSSUrl + '/hermannReichenspurner.jpg"),
      // img9Title:"Dr. Hermann Reichenspurner（赫尔曼·亥辛斯普尔纳）",
      // img9Address:"心血管外科专家，德国汉堡大学心脏中心医学部副主任",

      img10: baseOSSUrl + '/xavierRuyra.png',
      img10Title:"泽维尔·鲁伊拉博士",
      img10EnTitle:"Dr. Xavier Ruyra",
      img10Address:"巴塞罗那Teknon医疗中心心脏健康研究所所长",

      img11: baseOSSUrl + '/lcy.png',
      img11Title:"卢才义 教授、博士生导师",
      img11EnTitle:"",
      img11Address:"广州巴塞罗那医院心脏中心主任",

      img12: baseOSSUrl + '/dabit.png',
      img12Title:"达比·阿尔扎门迪博士",
      img12EnTitle:"Dr. Dabit Arzamendi",
      img12Address:"介入性心脏病专家、巴塞罗那自治大学的副教授",

      img13: baseOSSUrl + '/danielPereda.jpg',
      img13Title:"丹尼尔·佩雷达博士",
      img13EnTitle:"Dr. Daniel Pereda",
      img13Address:"巴塞罗那医院心血管外科顾问医生",

      img14: baseOSSUrl + '/jeroenBax.png',
      img14Title:"杰罗恩·巴克斯博士",
      img14EnTitle:"Dr. Jeroen Bax",
      img14Address:"莱顿大学医学中心心脏病学教授、无创成像和回声实验室主任、欧洲心脏病协会前任主席",

    }
  }
}
</script>

<style scoped>
  .proDivClass{
    background: linear-gradient(180deg, rgba(246, 248, 253, 0) 0%, rgba(12, 55, 124, 0.32) 100%)!important;
  }
  .picture{
    width: 17.75rem;
    height: 17.75rem;
  }
  .proImg{
    width: 17.8125rem;
    height: 17.8125rem;
  }
</style>